<template>
  <footer class="premium-footer">
    <div class="premium-footer__inner">
      <div class="footer-top">
        <div class="footer-brand">
          <div class="footer-brand__mark">
            <img
              src="@/assets/ministryOfHealthLogo.png"
              alt="Federal Ministry of Health"
              width="643"
              height="240"
              class="footer-brand__logo"
            />
          </div>

          <div class="footer-brand__copy">
            <span class="footer-kicker">Federal Ministry of Health</span>
            <h2>Health Partners' Projects & Data Mapping Platform</h2>
            <p>
              Department of Health Planning, Research and Statistics, Federal Ministry of Health,
              11th floor, New Federal Secretariat Complex, Phase II, Central Business District
              (FCT), Abuja Nigeria.
            </p>
            <b-link to="/ngo/contact-us" class="footer-contact">
              <i class="fas fa-envelope-open-text"></i>
              <span>Contact Us</span>
            </b-link>
          </div>
        </div>

        <div class="footer-grid">
          <section class="footer-column">
            <h3>Quick Links</h3>
            <ul>
              <li><b-link to="/">Home</b-link></li>
              <li><b-link to="/inventory/project">Project Inventory</b-link></li>
              <li><b-link to="/inventory/dataset">Data Inventory</b-link></li>
            </ul>
          </section>

          <section class="footer-column">
            <h3>Inventory Partners</h3>
            <ul>
              <li>
                <a target="_blank" rel="noopener noreferrer" href="https://ehealth4everyone.com/">
                  eHealth4everyone
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.gatesfoundation.org/"
                >
                  Bill and Melinda Gates Foundation
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.health.gov.ng/index.php/department/information-communication-technology"
                >
                  FMOH-ICT Department
                </a>
              </li>
            </ul>
          </section>

          <section class="footer-column">
            <h3>Other Links</h3>
            <ul>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://dhis2nigeria.org.ng/dhis/dhis-web-commons/security/login.action"
                >
                  DHIS2 Nigeria
                </a>
              </li>
              <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.health.gov.ng/">
                  Federal Ministry Of Health
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://nigerianstat.gov.ng/nada/index.php/catalog"
                >
                  National Bureau of Statistics
                </a>
              </li>
            </ul>
          </section>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© 2025 Federal Ministry of Health. All Rights Reserved.</p>
        <div class="social-icons">
          <a href="#" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
          <a href="#" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
          <a href="#" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
};
</script>

<style scoped>
.premium-footer {
  padding: 2.5rem 1rem 1.25rem;
  background: #edf3ee;
  border-top: 1px solid #e0e9df;
}

.premium-footer__inner {
  position: relative;
  max-width: 1440px;
  margin: 0 auto;
  padding: clamp(1.5rem, 3.5vw, 3.5rem);
  overflow: hidden;
  border: 1px solid #dce6dc;
  border-radius: 28px;
  background: radial-gradient(ellipse at top left, #f0f6e9, transparent 55%), #fcfdf9;
  box-shadow: 0 20px 60px rgba(23, 56, 35, 0.06);
}

.premium-footer__inner::before {
  content: '';
  position: absolute;
  inset: 0 0 auto;
  height: 4px;
  background: linear-gradient(90deg, #244d35, #819b63 55%, #d4dfbb);
}

.footer-top {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  align-items: start;
  gap: clamp(2rem, 4vw, 4.5rem);
  padding-bottom: 2.5rem;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.75rem;
  min-width: 0;
}

.footer-brand__mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 272px;
  max-width: 100%;
  padding: 18px 20px;
  border: 1px solid #d6e2d1;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(37, 73, 44, 0.05);
}

.footer-brand__logo {
  display: block;
  width: 232px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

.footer-brand__copy {
  max-width: 34rem;
  min-width: 0;
}

.footer-kicker,
.footer-column h3 {
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.footer-kicker {
  display: block;
  margin-bottom: 0.8rem;
  color: #5f794e;
}

.footer-brand__copy h2 {
  margin: 0 0 1rem;
  font-size: clamp(1.4rem, 2.1vw, 1.9rem);
  font-weight: 600;
  letter-spacing: -0.035em;
  line-height: 1.25;
  color: #203f2d;
  text-wrap: balance;
}

.footer-brand__copy p {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.85;
  color: #637465;
}

.footer-contact {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  margin-top: 1.25rem;
  padding: 0.8rem 1.15rem;
  border: 1px solid #254d35;
  border-radius: 9px;
  background: #254d35;
  color: #ffffff;
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 600;
  transition: background 180ms ease;
}

.footer-contact:hover {
  background: #173a26;
  color: #ffffff;
  text-decoration: none;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(1rem, 2vw, 2rem);
  padding-top: 0.75rem;
}

.footer-column {
  min-width: 0;
  padding-top: 1.25rem;
  border-top: 1px solid #d5dfce;
}

.footer-column h3 {
  margin: 0 0 1.5rem;
  color: #34513a;
  line-height: 1.6;
}

.footer-column ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer-column li + li {
  margin-top: 1.15rem;
}

.footer-column a {
  display: inline-block;
  color: #617262;
  font-size: 0.84rem;
  text-decoration: none;
  line-height: 1.7;
  overflow-wrap: anywhere;
  transition: color 180ms ease;
}

.footer-column a:hover {
  color: #235d35;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-top: 1.5rem;
  border-top: 1px solid #dce5d7;
}

.footer-bottom p {
  margin: 0;
  color: #6c7b6a;
  font-size: 0.74rem;
  line-height: 1.7;
}

.social-icons {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}

.social-icons a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #d5e0cf;
  border-radius: 50%;
  background: #eef4e7;
  color: #34593b;
  text-decoration: none;
  transition: background 180ms ease, color 180ms ease;
}

.social-icons a:hover {
  background: #254d35;
  color: #ffffff;
}

.premium-footer a:focus-visible {
  outline: 2px solid #63864c;
  outline-offset: 5px;
}

@media (max-width: 991px) {
  .footer-top {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .footer-brand__copy {
    max-width: 42rem;
  }
}

@media (max-width: 575px) {
  .premium-footer {
    padding: 1.5rem 0.5rem 0.75rem;
  }

  .premium-footer__inner {
    padding: 1.5rem;
    border-radius: 20px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 1.75rem;
  }

  .footer-column h3 {
    margin-bottom: 0.85rem;
  }

  .footer-column li + li {
    margin-top: 0.7rem;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (prefers-reduced-motion: reduce) {
  .premium-footer a {
    transition: none;
  }
}
</style>
